module.exports = __webpack_public_path__ + "img/clock-twelve-thirty.348de4c3.svg";